import { ITEM_TYPE_ICON_CLASSES } from "common/components/ItemTypeIcon";

angular.module("ticketco/common").component("itemTypeIcon", {
  bindings: {
    type: "@",
    size: "@",
    className: "@",
  },
  controller: componentController,
  template:
    "<i class='type' ng-class='$ctrl.getClassName({type: $ctrl.type, size: $ctrl.size, className: $ctrl.className})' title='{{ $ctrl.type | localizeType }}'></i>",
});

function componentController() {
  var self = this;
  var prefix = "t-icon-";

  self.getClassName = function(x) {
    var classes = [];
    var selectedType =
      ITEM_TYPE_ICON_CLASSES[x.type] || prefix + "entry_ticket";

    classes.push(selectedType);

    var sizes = {
      medium: "t-icon__medium",
      big: "t-icon__big",
      huge: "t-icon__huge",
    };

    var selectedSize = sizes[x.size];

    classes.push(selectedSize);
    classes.push(x.className);

    return classes.filter(Boolean).join(" ");
  };
}
